"use strict";

export default class CompanyScout {
  updateApplicationStatus(id, target) {
    $.ajax({
      url: Routes.update_application_status_scouts_path(gon.locale),
      method: 'PUT',
      data: {
        id,
        value: target.value
      },
      success: (response) => {
        $(target).siblings('span').html(response.message)
      },
      error: () => {
        alert('There was an error while updating application status in scouts list.');
      }
    })

    CompanyOfferReport.showButtonCompanyOfferReport(target);
  }
}
